import { render, staticRenderFns } from "./card-vital-tab.vue?vue&type=template&id=7412e42f&scoped=true&"
import script from "./card-vital-tab.vue?vue&type=script&lang=js&"
export * from "./card-vital-tab.vue?vue&type=script&lang=js&"
import style0 from "./card-vital-tab.vue?vue&type=style&index=0&id=7412e42f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7412e42f",
  null
  
)

export default component.exports